import styled, { css } from 'styled-components';
import themeColors from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';

import { BodyStrong } from '../LegacyText';
import type { TagSize } from './types';
import { TagVariant } from './types';

const getTextColor = (variant: TagVariant) => {
  switch (variant) {
    case TagVariant.GREY:
    case TagVariant.BLACK:
    case TagVariant.RED:
    case TagVariant.GREEN:
    case TagVariant.BLUE:
    case TagVariant.PURPLE:
      return themeColors.textPrimaryInverse;
    case TagVariant.DARK_GREY:
      return themeColors.iconSecondaryInverse;
    case TagVariant.TRANSPARENT:
      return themeColors.textHelper;
    case TagVariant.WHITE:
    case TagVariant.LIGHT_GREY:
    case TagVariant.YELLOW:
    case TagVariant.GENAI:
      return themeColors.textPrimary;
    case TagVariant.LIGHT_PURPLE:
      return themeColors.textAccent;
    default:
      return themeColors.textPrimary;
  }
};

export const Wrapper = styled.span<{
  $variant: TagVariant;
  $size: TagSize;
  $isIconOnly: boolean;
}>`
  display: inline-flex;
  gap: ${themeSpacing.xs1};
  align-items: center;
  justify-content: center;

  min-width: 24px;
  height: ${({ $size }) => ($size === 'small' ? themeSpacing.sm2 : themeSpacing.sm3)};

  color: ${({ $variant }) => getTextColor($variant)};

  background-color: ${({ $variant }) =>
    $variant === TagVariant.TRANSPARENT
      ? 'transparent'
      : themeColors[$variant]};
  border-radius: ${themeSpacing.radiusXSmall};

  ${({ $size, $isIconOnly }) => {
    if ($isIconOnly) {
      return css`
        padding: ${$size === 'regular' ? themeSpacing.xs1 : themeSpacing.xxs2};
      `;
    }
    return css`
        padding: ${$size === 'regular' ? themeSpacing.xs1 : themeSpacing.xxs2}
          ${themeSpacing.xs2};
      `;
  }};
`;

export const Text = styled(props => <BodyStrong {...props} as="span" />)`
  font-size: ${themeSpacing.xs3};
  color: inherit;
`;
